var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5295_1689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0H0.5V20H20.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5295_1689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1 10.2271C20.1 9.51804 20.0364 8.83624 19.9182 8.18164H10.5V12.0498H15.8818C15.65 13.2998 14.9455 14.3589 13.8864 15.068V17.5771H17.1182C19.0091 15.8362 20.1 13.2725 20.1 10.2271Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 19.9999C13.1999 19.9999 15.4635 19.1044 17.118 17.5772L13.8862 15.0681C12.9908 15.6681 11.8453 16.0226 10.4999 16.0226C7.89528 16.0226 5.69078 14.2635 4.90438 11.8999H1.56348V14.4908C3.20898 17.759 6.59078 19.9999 10.4999 19.9999Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9045 11.9002C4.7045 11.3002 4.5909 10.6593 4.5909 10.0002C4.5909 9.34108 4.7045 8.70018 4.9045 8.10018V5.50928H1.5636C0.8864 6.85928 0.5 8.38658 0.5 10.0002C0.5 11.6138 0.8864 13.1411 1.5636 14.4911L4.9045 11.9002Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 3.9773C11.968 3.9773 13.2862 4.4818 14.3226 5.4727L17.1908 2.6045C15.459 0.9909 13.1953 0 10.4999 0C6.59078 0 3.20898 2.2409 1.56348 5.5091L4.90438 8.1C5.69078 5.7364 7.89528 3.9773 10.4999 3.9773Z",
    fill: "#E94235"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.857df3b4b7ed3a5f511e0c55204f75dc.svg";
export { ForwardRef as ReactComponent };